import axios from "axios";
import React from "react";
import { useContext } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager";
import { RestAttributeCacheInputBean, RestLoginBean } from "../ds/ds.js";
import { Themes } from "../ds/ThemeScheme.js";
import { FaEye, FaEyeSlash } from "../gui_components/Icons.js";
import { ProgressBar, ShowError } from "../gui_components/UIComponents.js";
import {
  focusNextElement,
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CreditMemoService } from "../services/CreditMemoService.js";
import { CustomerReturnService } from "../services/CustomerReturnService.js";
import { CustomerService } from "../services/CustomerService.js";
import { ECommerceConnectorService } from "../services/ECommerceConnectorService.js";
import { EntityLockService } from "../services/EntityLockService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { LogisticOrderReceiptService } from "../services/LogisticOrderReceiptService.js";
import { LogisticOrderService } from "../services/LogisticOrderService.js";
import { MasterService } from "../services/MasterService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { PreProductionService } from "../services/PreProductionService.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { SecurityService } from "../services/SecurityService.js";
import { UserService } from "../services/UserService.js";
import { VendorService } from "../services/VendorService.js";
import { CPMRestService } from "../services/CPMRestService.js";
import { DebitMemoService } from "../services/DebitMemoService.js";

class UserSignInForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userCode: "",
      password: "",
      company: "",
      loginErrorMessage: "",
      isLoading: false,
      isShowProgressBarPopup: false,
      alertMessage: new Array(),
      alertType: "",
      isShowAlert: false,
      isInitial: true,
      isVisible: false,
      type: "password",
      errorMsg: "",
    };
  }

  onChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };

  login = (url, company, appData) => {
    this.setState({
      isLoading: true,
      progressLoadingText: "Logging in ..",
      isShowProgressBarPopup: true,
    });

    let userCode = this.state.userCode;
    let password = this.state.password;
    let loginBean = new RestLoginBean();
    loginBean.code = userCode;
    loginBean.password = password;
    loginBean.companyCode = company;

    const _url = url + "/LoginRestService" + "/login";
    axios({
      method: "post",
      url: _url,
      data: loginBean,
      headers: {
        "Access-Control-Allow-Origin": "*",
        securitykey: "RESTTEST1234",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let responseData = response.data;
        if (responseData.success) {
          this.props.onLoginSuccess(responseData, appData);
          this.setState({ isLoading: false });
        } else {
          const errorMsg = "Invalid User / Password";
          this.setState({
            errorMsg: errorMsg,
          });
          this.setState({ isLoading: false, isShowProgressBarPopup: false });
        }
      })
      .catch((error) => {
        ShowError("Erro : " + error);
      });
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      focusNextElement();
    }
  };
  closeAlertModalCallBack = (isShowProgressBarPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowProgressBarPopup,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
    });
  };

  getLogoURL = (serviceUrl, imgName) => {
    var url = "";
    if (!isEmptyString(serviceUrl) && !isEmptyString(imgName)) {
      url = serviceUrl + "/logo?file=" + imgName;
    }
    return url;
  };
  getMainImgURL = (serviceUrl, imgName) => {
    var url = "";
    if (!isEmptyString(serviceUrl) && !isEmptyString(imgName)) {
      url = serviceUrl + "/image?file=" + imgName;
    }
    return url;
  };
  toggleHandler = () => {
    this.state.isVisible
      ? this.setState({
          isVisible: false,
          type: "password",
        })
      : this.setState({
          isVisible: true,
          type: "text",
        });
  };
  setUserPreferTheme = () => {
    const themeId = localStorage.getItem("themeId");
    if (themeId != "" && themeId != undefined && themeId != null) {
      let theme = {};
      Themes.map((ln) => {
        if (ln.id === parseFloat(themeId)) {
          theme = ln.theme;
        }
      });
      if (theme) {
        document.documentElement.style.setProperty("--text", theme.text);
        document.documentElement.style.setProperty(
          "--background",
          theme.background
        );
        document.documentElement.style.setProperty("--primary", theme.primary);
        document.documentElement.style.setProperty(
          "--secondary",
          theme.secondary
        );
        document.documentElement.style.setProperty("--accent", theme.accent);
      }
    }
  };
  componentDidMount = () => {
    this.setUserPreferTheme();
  };
  render() {
    const isVisible = this.state.isVisible;
    const type = this.state.type;
    const error = this.state.errorMsg;
    return (
      <AppContext.Consumer>
        {({ appData }) => (
          <div id="moduleContainer" className="module_container">
            <div className="App">
              <div className="login-cnt">
                <ProgressBar
                  progressLoadingText={this.state.progressLoadingText}
                  isShowPopup={this.state.isShowProgressBarPopup}
                />
                <div className="login-background">
                  {" "}
                  <img
                    src={this.getMainImgURL(
                      appData.serviceURL,
                      appData.applicationMainImagePath
                    )}
                    mode="fit"
                  />
                </div>
                <div className="login-container">
                  <div className="login-wrapper">
                    <div className="login-header ">
                      <div>
                        {appData.applicationName} -{" "}
                        <span className="login-app-version"> V </span>
                        {/* <span className="login-app-version"> */}
                        {/* {appData.guiVersion} */}
                        {process.env.REACT_APP_GUI_VERSION}
                        {/* </span> */}
                      </div>
                    </div>
                    <div className="login-logo">
                      <img
                        src={this.getLogoURL(
                          appData.serviceURL,
                          appData.applicationLogoImagePath
                        )}
                        width={180}
                        height={100}
                        mode="fit"
                      />
                    </div>
                    <form>
                      <div className="login-input-wrp ">
                        <input
                          type="text"
                          // placeholder="USERNAME"
                          id="username"
                          required
                          name="userCode"
                          value={this.state.userCode}
                          onChange={(e) => this.onChange(e)}
                          onKeyDown={this.handleKeyDown}
                          className="form-input"
                          autoComplete="off"
                        />
                        <div className="form-cut fc1"></div>
                        <label htmlFor="username" className="form-placeholder">
                          User
                        </label>
                      </div>
                      <div className="login-pswd-wrp ">
                        <input
                          type={type}
                          // placeholder="PASSWORD"
                          required
                          name="password"
                          id="password"
                          value={this.state.password}
                          onChange={(e) => this.onChange(e)}
                          onKeyDown={this.handleKeyDown}
                          className="form-input"
                          autoComplete="off"
                        />
                        <span className="eye-icon" onClick={this.toggleHandler}>
                          {isVisible ? (
                            <i>
                              <FaEyeSlash />
                            </i>
                          ) : (
                            <i>
                              <FaEye />
                            </i>
                          )}
                        </span>
                        <div className="form-cut fc2"></div>
                        <label htmlFor="password" className="form-placeholder">
                          {" "}
                          Password{" "}
                        </label>
                      </div>
                      <input type="text" value={appData.companyCode} disabled />
                      <Button
                        className="enterFocus"
                        onClick={() =>
                          this.login(
                            appData.serviceURL,
                            appData.companyCode,
                            appData
                          )
                        }
                      >
                        Login
                      </Button>
                    </form>
                    {!isEmptyString(error) ? (
                      <div class="form-error">{error}</div>
                    ) : null}
                    <div className="login-footer">
                      <div>Powered by Advanced ERP USA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}

function UserSignInModule() {
  //const history = useHistory();
  const navigate = useNavigate ();
  const onLoginSuccess = (data, appData) => {
    localStorage.setItem("session", JSON.stringify(data.sessionBean));
    localStorage.setItem(
      "security_token",
      JSON.stringify(data.sessionBean.securityPass)
    );
    if (
      !isEmpty(data.entitlementPageListResponse) &&
      !isEmpty(data.entitlementPageListResponse.entitlementPageList)
    ) {
      let entitlements =
        data.entitlementPageListResponse.entitlementPageList.entitlements;
      if (!isEmptyArray(entitlements)) {
        localStorage.removeItem("entitlements");
        localStorage.setItem("entitlements", JSON.stringify(entitlements));
      } else {
        localStorage.removeItem("entitlements");
        localStorage.setItem("entitlements", JSON.stringify([]));
      }
    }
    localStorage.setItem("companyConfig", JSON.stringify(data.companyConfigs));
    localStorage.setItem("configs", JSON.stringify(data.configs));
    ConfigManager.initConfigs();
    SalesOrderService.initService(appData);
    FabricStyleService.initService(appData);
    CustomerService.initService(appData);
    ReportService.initService(appData);
    PurchaseOrderService.initService(appData);
    InventoryService.initService(appData);
    PickTicketService.initService(appData);
    InvoiceService.initService(appData);
    AccountReceivableService.initService(appData);
    AccountPayableService.initService(appData);
    PurchaseOrderReceiptService.initService(appData);
    PurchaseOrderInTransitService.initService(appData);
    VendorService.initService(appData);
    MasterService.initService(appData);
    EntityLockService.initService(appData);
    UserService.initService(appData);
    SecurityService.initService(appData);
    CreditMemoService.initService(appData);
    CustomerReturnService.initService(appData);
    ECommerceConnectorService.initService(appData);
    PreProductionService.initService(appData);
    LogisticOrderService.initService(appData);
    LogisticOrderReceiptService.initService(appData);
    CPMRestService.initService(appData);
    DebitMemoService.initService(appData);

    SecurityAccessManager.initEntitlements();

    // let cacheInput = new RestAttributeCacheInputBean();
    // cacheInput.companyCode = appData.companyCode;
    // const _url = appData.serviceURL + "/MasterRestService/getAttributeCache";
    // axios({
    //   method: "post",
    //   url: _url,
    //   data: cacheInput,
    //   headers: {
    //     "Access-Control-Allow-Origin": "*",
    //     securitykey: "RESTTEST1234",
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => {
    //     let responseData = response.data;
    //     if (responseData.success) {
    //       setTimeout(() => {
    //         localStorage.setItem(
    //           "attributeCache",
    //           JSON.stringify(responseData.attributeCache)
    //         );

    //         history.push({
    //           pathname: "/main",
    //           state: { loginSession: data.sessionBean },
    //         });
    //       }, 400);
    //     } else {
    //       ShowError("Unable to Load Cache!");
    //     }
    //   })
    //   .catch((error) => {
    //     ShowError("Erro : " + error);
    //   });
    /*
    history.push({
      pathname: "/main",
      state: { loginSession: data.sessionBean },
    });
    */
    
    navigate("/main", { state: { loginSession: data.sessionBean } });
    
  };

  return <UserSignInForm onLoginSuccess={onLoginSuccess} name="" />;
}

export default UserSignInModule;
